import React from 'react';
import '../assets/css/style.css'; // Import your custom CSS
import img1 from '../assets/css/img/image1.png'
import img2 from '../assets/css/img/image2.png'
import img3 from '../assets/css/img/image3.png'
import img4 from '../assets/css/img/image4.png'
import frame1 from '../assets/css/img/framew.png'
import frame2 from '../assets/css/img/framew2.png'
import frame3 from '../assets/css/img/framew3.png'
import frame4 from '../assets/css/img/framew4.png'
import frame5 from '../assets/css/img/framew5.png'
import shock from '../assets/css/img/shock2.png'

const Solar = () => {
  return (
    <section id='Solutions'>
    <div className="solar-solutions-container" >
      <section className="solutions-section">
        <div className="container">
        <h1 className="ps-5 white-heading text-center">
          <img src={shock} className='shock' alt="Shock Icon" />&nbsp;Solutions
        </h1>
          <h3 className="ps-5 sub-heading text-center ">Solar Energy Solutions</h3>
          <div className="row solution-items">
            <div className="col-6 col-md-3 text-center">
              <div className="solution-item">
                <img src={img1} alt="MSMEs" className="img-fluid" />
                <p>MSMEs</p>
              </div>
            </div>
            <div className="col-6 col-md-3 text-center">
              <div className="solution-item">
                <img src={img2} alt="Commercial" className="img-fluid" />
                <p>Commercial</p>
              </div>
            </div>
            <div className="col-6 col-md-3 text-center">
              <div className="solution-item">
                <img src={img3} alt="Enterprises" className="img-fluid" />
                <p>Enterprises</p>
              </div>
            </div>
            <div className="col-6 col-md-3 text-center">
              <div className="solution-item">
                <img src={img4} alt="Residential" className="img-fluid" />
                <p>Residential</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="advantage-section">
  <div className="container-fluid">
    <h1 className="p-5 white-heading text-center p-4">
      <img src={shock} className='shock' alt="Shock Icon" />&nbsp;Solar Services
    </h1>
    <div className="row advantage-items">
    <div className="col-lg-1 col-md-0 text-center "></div>
      <div className="col-6 col-md-2 text-center border-right">
        <div className="advantage-item">
          <img src={frame1} alt="Experience" className="img-fluid" />
          <p>30+ Years Experience</p>
        </div>
      </div>
      <div className="col-6 col-md-2 text-center border-right">
        <div className="advantage-item">
          <img src={frame2} alt="Quality" className="img-fluid" />
          <p>Trusted Quality Assurance</p>
        </div>
      </div>
      <div className="col-6 col-md-2 text-center border-right">
        <div className="advantage-item">
          <img src={frame3} alt="Sales" className="img-fluid" />
          <p>Exclusive sales & service</p>
        </div>
      </div>
      <div className="col-6 col-md-2 text-center border-right">
        <div className="advantage-item">
          <img src={frame4} alt="Support" className="img-fluid" />
          <p>Lifetime service support</p>
        </div>
      </div>
      <div className="col-6 col-md-2 text-center border-right">
        <div className="advantage-item">
          <img src={frame5} alt="Insurance" className="img-fluid" />
          <p>Insurance for Solar</p>
        </div>
      </div>
    </div>
  </div>
</section>
    </div>
    </section>
  );
};

export default Solar;
